var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreGrantees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48633 10.6251L8.57812 6.37509L10.6699 10.6251L8.57812 9.20842L6.48633 10.6251Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.591 3.73285L10.6706 -6.10352e-05H6.48698L5.56659 3.73285C4.78071 4.24592 4.13426 4.9513 3.68656 5.78422C3.23886 6.61714 3.00427 7.55094 3.00427 8.49994C3.00427 9.44894 3.23886 10.3827 3.68656 11.2157C4.13426 12.0486 4.78071 12.754 5.56659 13.267L6.48698 16.9999H10.6706L11.591 13.267C12.3768 12.754 13.0233 12.0486 13.471 11.2157C13.9187 10.3827 14.1533 9.44894 14.1533 8.49994C14.1533 7.55094 13.9187 6.61714 13.471 5.78422C13.0233 4.9513 12.3768 4.24592 11.591 3.73285ZM8.57878 12.7499C7.75134 12.7499 6.94248 12.5007 6.25449 12.0337C5.5665 11.5667 5.03029 10.9029 4.71365 10.1264C4.397 9.34976 4.31415 8.49523 4.47558 7.67081C4.637 6.84639 5.03546 6.0891 5.62055 5.49473C6.20564 4.90036 6.95107 4.49559 7.76261 4.33161C8.57414 4.16762 9.41531 4.25178 10.1798 4.57345C10.9442 4.89513 11.5976 5.43985 12.0573 6.13876C12.517 6.83766 12.7624 7.65937 12.7624 8.49994C12.7624 9.62711 12.3216 10.7081 11.537 11.5051C10.7524 12.3022 9.68834 12.7499 8.57878 12.7499Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.1562,
    height: 17,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreGrantees);
export default __webpack_public_path__ + "static/media/PreGrantees.463ebd14.svg";
export { ForwardRef as ReactComponent };